module.exports = __webpack_public_path__ + "static/media/Social_Discord.7c986c03.svg";